import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../../shared/services/notification.service";
import { DossierGedViewModel } from "../../../../Helper/DocumentGedHelper";

@Component
export default class ModalAjoutEditDossier extends Vue {
    public nomDossierOuDocument = "";
    public fichier = "";
    public nomFichierLocal = "";
    public modeDocument = false;
    public type = "";
    public extension = "";
    public isLoading = false;
    public dossier?: DossierGedViewModel;

    public init(dossier: DossierGedViewModel, estModeDocument: boolean): void {
        this.isLoading = false;
        this.dossier = dossier;
        this.modeDocument = estModeDocument;
        this.nomDossierOuDocument = "";
        this.nomFichierLocal = "";
        this.fichier = "";
        this.type = "";
        this.$forceUpdate();
    }

    public enregistrer(): void {
        if (!this.controleSaisie() || this.dossier === undefined) {
            return;
        }

        this.isLoading = true;
        if (this.modeDocument) {
            ServicesFactoryInstance.GedService.ajoutDocument({
                file: this.fichier,
                Description: this.nomDossierOuDocument,
                DossierCheminLogique: this.dossier.CheminLogique,
                Extension: this.extension,
                Nom: this.nomDossierOuDocument,
                Code: "",
                DateDeCreation: new Date(),
                DateDeModification: new Date(),
                Type: this.type
            }, () => {
                this.isLoading = true;
                this.$emit("completed", this.dossier);
                $("#modalAjoutEditDossier").modal("hide");
            }, () => { this.isLoading = false; });
        } else {
            ServicesFactoryInstance.GedService.ajoutDossier({
                CheminLogique: this.dossier.CheminLogique + "/" + this.nomDossierOuDocument,
                Code: "",
                Nom: this.nomDossierOuDocument,
                DateDeCreation: new Date(),
                DateDeModification: new Date()
            }, () => {
                this.isLoading = false;
                this.$emit("completed", this.dossier);
                $("#modalAjoutEditDossier").modal("hide");
            }, () => { this.isLoading = false; });
        }
    }

    public controleSaisie(): boolean {
        const messages: string[] = [];
        if (this.nomDossierOuDocument == undefined || this.nomDossierOuDocument.trim().length == 0) {
            messages.push(`Le nom du ${this.modeDocument ? "document" : "dossier"} est obligatoire.`);
        }

        if (this.modeDocument && (this.fichier == undefined || this.fichier.trim().length == 0)) {
            messages.push("Un fichier doit être sélectionné.");
        }

        if (messages.length > 0) {
            for (let i = 0; i < messages.length; i++) {
                NotificationServiceInstance.SendFailed(messages[i]);
            }
        }

        return messages.length == 0;
    }

    public annuler(): void {
        $("#modalAjoutEditDossier").modal("hide");
    }

    public changeFile(event: any): void {
        const someData = event.target.files[0];

        this.type = someData.type;
        this.nomFichierLocal = someData.name;
        this.extension = someData.name.split(".").reverse()[0];

        const reader = new FileReader();
        const _this = this;
        let unit: ArrayBuffer;
        reader.onloadend = function () {
            const src = reader.result;
            if ((src as ArrayBuffer) != undefined) {
                unit = new Uint8Array(src as ArrayBuffer);
            }

            _this.updateSrc(unit);
        };

        if (someData) {
            reader.readAsArrayBuffer(someData);
        }
    }

    public updateSrc(data: any): void {
        this.fichier = data.toString();
    }
}




// WEBPACK FOOTER //
// ./src/components/ficheSalarie/documents/ajoutEditDossier/modalAjoutEditDossier.ts